<div id="Resume-builder" class="modal-backdrop" *ngIf="showModal" (click)="closeModal()"></div>
<div id="liveRegionLoginStatus" aria-live="polite" aria-atomic="true" class="sr-only"></div>
<div class="modal resume-modal" *ngIf="showModal" role="dialog" aria-modal="true" aria-labelledby="resumeTitle" cdkTrapFocus cdkTrapFocusAutoCapture tabindex="-1">
    <div class="resume-scrollable">
        <div id="success-popup" class="BorderSuccess baseColorPalette success-popup" [style.display]="isPopupVisible ? 'block' : 'none'">
            <div class="popup-content">
                <p>{{'Successfully_Saved_in_My_Files' | translate}}</p>
            </div>
        </div>
        <ng-container [ngSwitch]="getCurrentTemplate()">
            <!-- Modern Template (Two-Column) -->
            <ng-container *ngSwitchCase="'modern'">
                <div class="resume-content modern">
                    <div class="resume-header">
                        <table class="header-table" role="presentation">
                            <tr>
                                <td>
                                    <h1 id="resumeTitle" class="name">{{ getResponseValue('firstname') }} {{ getResponseValue('middlename') }} {{ getResponseValue('lastname') }}</h1>
                                </td>
                            </tr>
                            <tr>
                                <td class="details" tabindex="-1">
                                    <span><a href="mailto:{{ getResponseValue('email') }}">{{ getResponseValue('email') }}</a></span> |
                                    <span><a href="tel:{{ getResponseValue('homephone') }}">{{ getResponseValue('homephone') }}</a></span> |
                                    <span></span> | {{ getResponseValue('address1') }}, {{ getResponseValue('city') }}, {{ getResponseValue('fullstate') }} {{ getResponseValue('zip') }}, {{ getResponseValue('countryname') }}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="resume-body">
                        <table class="resume-table" role="presentation">
                            <tr>
                                <td class="left-column">
                                    <section class="skills-section resume-section">
                                        <h2>{{ 'Skills' | translate }}</h2>
                                        <ul class="skills-list">
                                            <li *ngFor="let skill of profileDetails.Skills">{{ skill | sanitize }}</li>
                                        </ul>
                                    </section>
                                    <section *ngFor="let section of customSections" class="custom-section resume-section">
                                        <h2>{{ section.Title }}</h2>
                                        <ul>
                                            <li *ngFor="let item of section.Items">{{ item | sanitize }}</li>
                                        </ul>
                                    </section>
                                </td>
                                <td class="right-column">
                                    <section class="experience-section resume-section">
                                        <h2>{{ 'Work_Experience' | translate }}</h2>
                                        <div *ngFor="let exp of sortedExperience" class="experience-block">
                                            <h3>{{ exp.EmployerName | sanitize }}</h3>
                                            <p>{{ exp.PositionTitle | sanitize }}</p>
                                            <p>{{ exp.NewStartDate || exp.StartDate }} - {{ exp.NewEndDate || exp.EndDate }}</p>
                                            <div *ngIf="exp.Responsibilities" class="responsibilities-text">
                                                <p>Responsibilities:</p>
                                                <pre class="responsibilities-text" [innerHTML]="exp.Responsibilities | sanitize"></pre>
                                            </div>
                                        </div>
                                    </section>
                                    <section class="education-section resume-section">
                                        <h2>{{ 'Education_History' | translate }}</h2>
                                        <div *ngIf="mostRecentEducation" class="education-item most-recent-education">
                                            <h3>{{ 'SchoolName' | translate |sanitize }}</h3>
                                            <p *ngIf="mostRecentEducation.Major">{{ mostRecentEducation.Major | sanitize }}</p>
                                            <p>{{ mostRecentEducation.Degree | sanitize }}, {{ mostRecentEducation.Location | sanitize }}</p>
                                            <p>Graduation Year: {{ mostRecentEducation.GradYear || 'N/A' | sanitize }}</p>
                                        </div>
                                        <div *ngFor="let edu of otherEducation" class="education-item">
                                            <h3>{{ edu.SchoolName | sanitize }}</h3>
                                            <p *ngIf="edu.Major">{{ edu.Major | sanitize }}</p>
                                            <p>{{ edu.Degree | sanitize }}, {{ edu.Location | sanitize }}</p>
                                            <p>Graduation Year: {{ edu.GradYear || 'N/A' | sanitize }}</p>
                                        </div>
                                    </section>

                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </ng-container>

            <!-- Elegant Template (Single-Column, Clean Layout) -->
            <ng-container *ngSwitchCase="'elegant'">
                <div class="resume-content elegant">
                    <div class="resume-header">
                        <h1 id="resumeTitle" class="name">{{ getResponseValue('firstname') }} {{ getResponseValue('middlename') }} {{ getResponseValue('lastname') }}</h1>
                        <p class="contact" tabindex="-1">
                            <span>{{ getResponseValue('email') }}</span> |
                            <span>{{ getResponseValue('homephone') }}</span> |
                        </p>
                        <p class="location">
                            {{ getResponseValue('address1') }}, {{ getResponseValue('city') }}, {{ getResponseValue('fullstate') }} {{ getResponseValue('zip') }}, {{ getResponseValue('countryname') }}
                        </p>
                    </div>
                    <div class="resume-body">
                        <section class="experience-section resume-section">
                            <h2>{{ 'Work_Experience' | translate }}</h2>
                            <div *ngFor="let exp of sortedExperience" class="experience-block">
                                <h3>{{ exp.EmployerName | sanitize }}</h3>
                                <p>{{ exp.PositionTitle | sanitize }}</p>
                                <p>{{ exp.NewStartDate || exp.StartDate }} - {{ exp.NewEndDate || exp.EndDate }}</p>
                                <div *ngIf="exp.Responsibilities" class="responsibilities-text">
                                    <p>Responsibilities:</p>
                                    <pre class="responsibilities-text" [innerHTML]="exp.Responsibilities | sanitize"></pre>
                                </div>
                            </div>
                        </section>
                        <section class="education-section resume-section">
                            <h2>{{ 'Education_History' | translate }}</h2>
                            <div *ngIf="mostRecentEducation" class="education-item most-recent-education">
                                <h3>{{ mostRecentEducation.SchoolName | sanitize }}</h3>
                                <p *ngIf="mostRecentEducation.Major">{{ mostRecentEducation.Major | sanitize }}</p>
                                <p>{{ mostRecentEducation.Degree | sanitize }}, {{ mostRecentEducation.Location | sanitize }}</p>
                                <p>Graduation Year: {{ mostRecentEducation.GradYear || 'N/A' | sanitize }}</p>
                            </div>
                            <div *ngFor="let edu of otherEducation" class="education-item">
                                <h3>{{ edu.SchoolName | sanitize }}</h3>
                                <p *ngIf="edu.Major">{{ edu.Major | sanitize }}</p>
                                <p>{{ edu.Degree | sanitize }}, {{ edu.Location | sanitize }}</p>
                                <p>Graduation Year: {{ edu.GradYear || 'N/A' | sanitize }}</p>
                            </div>
                        </section>
                        <section class="skills-section resume-section">
                            <h2>{{ 'Skills' | translate }}</h2>
                            <ul class="skills-list">
                                <li *ngFor="let skill of profileDetails.Skills">{{ skill | sanitize }}</li>
                            </ul>
                        </section>
                        <section *ngFor="let section of customSections" class="custom-section resume-section">
                            <h2>{{ section.Title | sanitize }}</h2>
                            <ul>
                                <li *ngFor="let item of section.Items">{{ item | sanitize }}</li>
                            </ul>
                        </section>
                    </div>
                </div>
            </ng-container>
            <!-- Creative Template (Sidebar Layout) -->
            <ng-container *ngSwitchCase="'creative'">
                <div class="resume-content creative">
                    <div class="resume-header">
                        <h1 id="resumeTitle" class="name">{{ getResponseValue('firstname') }} {{ getResponseValue('middlename') }} {{ getResponseValue('lastname') }}</h1>
                        <p class="contact" tabindex="-1">
                            <span><i class="fa fa-envelope"></i> {{ getResponseValue('email') }}</span> |
                            <span><i class="fa fa-phone"></i> {{ getResponseValue('homephone') }}</span> |
                        </p>
                    </div>
                    <div class="resume-body sidebar-layout">
                        <div class="sidebar">
                            <section class="skills-section resume-section">
                                <h2>{{ 'Skills' | translate }}</h2>
                                <ul class="skills-list">
                                    <li *ngFor="let skill of profileDetails.Skills">{{ skill | sanitize }}</li>
                                </ul>
                            </section>
                            <section *ngFor="let section of customSections" class="custom-section resume-section">
                                <h2>{{ section.Title | sanitize }}</h2>
                                <ul>
                                    <li *ngFor="let item of section.Items">{{ item | sanitize }}</li>
                                </ul>
                            </section>
                        </div>
                        <div class="main-content">
                            <section class="experience-section resume-section">
                                <h2>{{ 'Work_Experience' | translate }}</h2>
                                <div *ngFor="let exp of sortedExperience" class="experience-block">
                                    <h3>{{ exp.EmployerName | sanitize }}</h3>
                                    <p>{{ exp.PositionTitle | sanitize }}</p>
                                    <p>{{ exp.NewStartDate || exp.StartDate }} - {{ exp.NewEndDate || exp.EndDate }}</p>
                                    <div *ngIf="exp.Responsibilities" class="responsibilities-text">
                                        <p>Responsibilities:</p>
                                        <p class="responsibilities-text" [innerHTML]="exp.Responsibilities | sanitize"></p>
                                    </div>
                                </div>
                            </section>
                            <section class="education-section resume-section">
                                <h2>{{ 'Education_History' | translate }}</h2>
                                <div *ngIf="mostRecentEducation" class="education-item most-recent-education">
                                    <h3>{{ mostRecentEducation.SchoolName | sanitize }}</h3>
                                    <p *ngIf="mostRecentEducation.Major">{{ mostRecentEducation.Major | sanitize }}</p>
                                    <p>{{ mostRecentEducation.Degree | sanitize }}, {{ mostRecentEducation.Location | sanitize }}</p>
                                    <p>Graduation Year: {{ mostRecentEducation.GradYear || 'N/A' | sanitize }}</p>
                                </div>
                                <div *ngFor="let edu of otherEducation" class="education-item">
                                    <h3>{{ edu.SchoolName | sanitize }}</h3>
                                    <p *ngIf="edu.Major">{{ edu.Major | sanitize }}</p>
                                    <p>{{ edu.Degree | sanitize }}, {{ edu.Location | sanitize }}</p>
                                    <p>Graduation Year: {{ edu.GradYear || 'N/A' | sanitize }}</p>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- Classic Template (Traditional Single-Column) -->
            <ng-container *ngSwitchCase="'classic'">
                <div class="resume-content classic">
                    <div class="resume-header">
                        <h1 id="resumeTitle" class="name">{{ getResponseValue('firstname') }} {{ getResponseValue('middlename') }} {{ getResponseValue('lastname') }}</h1>
                        <p class="contact" tabindex="-1">
                            {{ getResponseValue('address1') }}, {{ getResponseValue('city') }}, {{ getResponseValue('fullstate') }} {{ getResponseValue('zip') }}, {{ getResponseValue('countryname') }} | {{ getResponseValue('homephone') }} | {{ getResponseValue('email') }} |
                        </p>
                    </div>
                    <div class="resume-scrollable-body">
                        <div class="resume-body single-column-layout">
                            <section class="experience-section resume-section">
                                <h2>{{ 'Work_Experience' | translate }}</h2>
                                <div *ngFor="let exp of sortedExperience" class="experience-block">
                                    <h3>{{ exp.EmployerName | sanitize }}</h3>
                                    <p>{{ exp.PositionTitle | sanitize }}</p>
                                    <p>{{ exp.NewStartDate || exp.StartDate }} - {{ exp.NewEndDate || exp.EndDate }}</p>
                                    <div *ngIf="exp.Responsibilities" class="responsibilities-text">
                                        <p>Responsibilities:</p>
                                        <pre class="responsibilities-text" [innerHTML]="exp.Responsibilities | sanitize"></pre>
                                    </div>
                                </div>
                            </section>
                            <section class="education-section resume-section">
                                <h2>{{ 'Education_History' | translate }}</h2>
                                <div *ngIf="mostRecentEducation" class="education-item most-recent-education">
                                    <h3>{{ mostRecentEducation.SchoolName | sanitize }}</h3>
                                    <p *ngIf="mostRecentEducation.Major">{{ mostRecentEducation.Major | sanitize }}</p>
                                    <p>{{ mostRecentEducation.Degree | sanitize }}, {{ mostRecentEducation.Location | sanitize }}</p>
                                    <p>Graduation Year: {{ mostRecentEducation.GradYear || 'N/A' | sanitize }}</p>
                                </div>
                                <div *ngFor="let edu of otherEducation" class="education-item">
                                    <h3>{{ edu.SchoolName | sanitize }}</h3>
                                    <p *ngIf="edu.Major">{{ edu.Major | sanitize }}</p>
                                    <p>{{ edu.Degree | sanitize }}, {{ edu.Location | sanitize }}</p>
                                    <p>Graduation Year: {{ edu.GradYear || 'N/A' | sanitize }}</p>
                                </div>
                            </section>
                            <section class="skills-section resume-section">
                                <h2>{{ 'Skills' | translate }}</h2>
                                <p>{{ profileDetails.Skills.join(', ') | sanitize }}</p>
                            </section>
                            <section *ngFor="let section of customSections" class="custom-section resume-section">
                                <h2>{{ section.Title | sanitize }}</h2>
                                <p>{{ section.Items.join(', ') | sanitize }}</p>
                            </section>
                        </div>
                    </div>
                </div>
            </ng-container>
            <!-- Edit Form (Hidden in PDF) -->
            <div id="editFormSection" class="edit-form" *ngIf="showEditForm">
                <h2>
                    {{ 'Modal_Add_Edit_Section' | translate }}
                    <i class="fa fa-info-circle help-icon" aria-hidden="true" title="Select a section type to add or edit content in your resume."></i>
                </h2>
                <div class="section-type-wrapper">
                    <label id="sectionTypeLabel" for="sectionType" [attr.aria-label]="'Modal_Section_Type' | translate">{{ 'Modal_Section_Type' | translate }}</label>
                    <div class="select-with-help">
                        <select id="sectionType" [(ngModel)]="newSectionType" (change)="newSectionTitle = newSectionType === 'Custom' ? '' : newSectionType">
                    <option value="" disabled>{{ 'Modal_Select_Section_Type' | translate }}</option>
                    <option value="Personal Details">{{ 'Modal_SectionType_Personal_Details' | translate }}</option>
                    <option value="Skills">{{ 'Skills' | translate }}</option>
                    <option value="Experience">{{ 'Work_Experience' | translate }}</option>
                    <option value="Education">{{ 'Education_History' | translate }}</option>
                    <option value="Custom">{{ 'Modal_SectionType_Custom_Section' | translate }}</option>
                  </select>
                    </div>
                </div>
                <!-- Personal Details Form -->
                <div *ngIf="newSectionType === 'Personal Details'" class="personal-details-form">
                    <h3>Existing Personal Details</h3>
                    <ul class="item-list">
                        <ng-container *ngFor="let key of personalDetailsKeys">
                            <li *ngIf="personalDetails[key]">
                                <span>{{ key | titlecase }}: {{ personalDetails[key] }}</span>
                                <i role="button" class="fa fa-trash remove-icon " [attr.aria-label]="'Delete ' + (key | titlecase) + ' ' + personalDetails[key]" tabindex="0" (keydown.enter)="removePersonalDetail(key)" (click)="removePersonalDetail(key)" title="Remove "></i>
                            </li>
                        </ng-container>
                    </ul>
                    <div class="field-group ">
                        <label id="firstnameLabel " for="firstname "><span class=" req ">*</span>{{'PersonalDetails_Label_First_Name' | translate}}</label>
                        <input aria-required="true " [translateStrings]="translateStrings " id="firstname " noSpecialChars name="firstname " [(ngModel)]="personalDetails[ 'firstname'] " required appFieldError maxlength="256 " placeholder="{{'PersonalDetails_Placeholder_Enter_First_Name' | translate}} "
                        />
                    </div>
                    <div class="field-group ">
                        <label id="middlenameLabel " for="middlename ">{{'Middle_Name' | translate}}</label>
                        <input id="middlename " noSpecialChars [(ngModel)]="personalDetails[ 'middlename'] " maxlength="256 " placeholder="{{'PersonalDetails_Placeholder_Enter_Middle_Name' | translate}} " />
                    </div>
                    <div class="field-group ">
                        <label id="lastnameLabel " for="lastname "><span class="req ">*</span>{{'Label_lastName' | translate}}</label>
                        <input aria-required="true " [translateStrings]="translateStrings " id="lastname " noSpecialChars name="lastname " [(ngModel)]="personalDetails[ 'lastname'] " maxlength="256 " required appFieldError placeholder="{{'PersonalDetails_Placeholder_Enter_Last_Name' | translate}} "
                        />
                    </div>
                    <div class="field-group ">
                        <label id="emailLabel " for="email "><span class="req ">*</span>{{'Label_Email' | translate}}</label>
                        <input aria-required="true" id="email" type="email" [(ngModel)]="personalDetails['email']" name="email" required appFieldError [translateStrings]="translateStrings" customEmail />
                    </div>

                    <div class="field-group ">
                        <label id="homephoneLabel " for="homephone "><span class="req ">*</span>{{'IM_PhoneType' | translate}}</label>
                        <input id="homephone" name="homephone" phoneValidator aria-required="true" [(ngModel)]="personalDetails['homephone']" maxlength="25" required placeholder="{{'PersonalDetails_Placeholder_Enter_Phone_Number' | translate}}" appFieldError [translateStrings]="translateStrings"
                        />
                    </div>

                    <div class="field-group ">
                        <label id="address1Label " for="address1 ">{{'PersonalDetails_Label_Address' | translate}}</label>
                        <input id="address1 " noSpecialChars [(ngModel)]="personalDetails[ 'address1'] " maxlength="256 " placeholder="{{'PersonalDetails_Placeholder_Enter_Address' | translate}} " />
                    </div>
                    <div class="field-group ">
                        <label id="cityLabel " for="city ">{{'City' | translate}}</label>
                        <input id="city " noSpecialChars [(ngModel)]="personalDetails[ 'city'] " maxlength="256 " placeholder="{{'PersonalDetails_Placeholder_Enter_City' | translate}} " />
                    </div>
                    <div class="field-group ">
                        <label id="fullstateLabel " for="fullstate ">{{'State' | translate}}</label>
                        <input id="fullstate " noSpecialChars [(ngModel)]="personalDetails[ 'fullstate'] " maxlength="256 " placeholder="{{'PersonalDetails_Placeholder_Enter_State' | translate}} " />
                    </div>
                    <div class="field-group ">
                        <label id="zipLabel " for="zip ">{{'Zip_Code' | translate}}</label>
                        <input id="zip " noSpecialChars [(ngModel)]="personalDetails[ 'zip'] " maxlength="256 " placeholder="{{'PersonalDetails_Placeholder_Enter_Zip_Code' | translate}} " />
                    </div>
                    <div class="field-group ">
                        <label id="countrynameLabel " for="countryname ">{{'Country' | translate}}</label>
                        <input id="countryname " noSpecialChars [(ngModel)]="personalDetails[ 'countryname'] " maxlength="256 " placeholder="{{'PersonalDetails_Placeholder_Enter_Country' | translate}} " />
                    </div>
                    <button class="primaryButton " (click)="savePersonalDetails() "><span class="ladda-label ">{{'PersonalDetails_Button_Save' | translate}}</span></button>
                </div>
                <!-- Skills Form -->
                <div *ngIf="newSectionType==='Skills' ">

                    <div class="sr-only" aria-live="polite" aria-atomic="true" aria-label="Skills update">
                        {{ skillAnnouncement }}
                    </div>

                    <h3>{{'Skills_Placeholder_Existing_Skills' | translate}}</h3>
                    <ul class="item-list ">
                        <li *ngFor="let skill of profileDetails.Skills; let i = index">
                            {{ skill }}
                            <i class="fa fa-trash remove-icon" role="button" #deleteBtn [attr.aria-label]="'Delete skill ' + skill" tabindex="0" (keydown.enter)="removeSkill(skill, i)" (click)="removeSkill(skill, i)" title="Remove">
                            </i>
                        </li>
                    </ul>

                    <h3>{{'Skills' | translate}}</h3>

                    <div class="skills-chips-container selection lightAccentBkg" *ngIf="tempSkills.length > 0">
                        <div class="skill-chip" *ngFor="let skill of tempSkills; let i = index">
                            <span class="skill-text">{{ skill }}</span>
                            <span class="closeButton">
                <span role="button"
                      class="remove-icon-btn"
                      (click)="removeTempSkill(i)"
                      [attr.aria-label]="'Remove skill ' + skill"
                      tabindex="0"
                      (keydown.enter)="removeTempSkill(i)"
                      (keydown.space)="removeTempSkill(i)">
                    <i class="fa fa-times-circle" aria-hidden="true"></i>
                </span>
                            </span>
                        </div>
                    </div>

                    <p *ngIf="tempSkills.length === 0" class="text-muted">
                        {{'Start_typing_a_skill' | translate}}
                    </p>

                    <hr />

                    <div class="input-wrapper">
                        <input #skillInput id="skillItem" type="text" [(ngModel)]="currentSkillInput" (keyup.enter)="addSingleSkill()" maxlength="80" placeholder="{{ 'Skills_Placeholder_Enter_Skill' | translate }}" class="skill-input-with-button" />

                        <button class="primaryButton add-btn-inside" (click)="addSingleSkill()" [disabled]="!currentSkillInput">
            <span class="ladda-label">{{'Button_Add' | translate}}</span>
        </button>
                    </div>

                    <div class="mt-4 text-right">
                        <button class="primaryButton" (click)="saveAllSkills()" [disabled]="tempSkills.length === 0">
            <span class="ladda-label">
                {{'Skills_Save_Skills' | translate}} ({{ tempSkills.length }})
            </span>
        </button>
                    </div>

                </div>

                <!-- Experience Form -->
                <div *ngIf="newSectionType==='Experience' " class="experience-details-form">
                    <h3>{{'Existing_Experience' | translate}}</h3>
                    <ul class="item-list ">
                        <li *ngFor="let exp of profileDetails.Experience ">
                            {{ exp.PositionTitle }} at {{ exp.EmployerName }}
                            <i class="fa fa-trash remove-icon " role="button" [attr.aria-label]="'Delete experience ' + exp.PositionTitle  + exp.EmployerName" tabindex="0" (keydown.enter)="removeExperience(exp)" (click)="removeExperience(exp)" title="Remove "></i>
                        </li>
                    </ul>
                    <div class="form-group ">
                        <label id="positionTitleLabel"><span class="req">*</span>{{'Company' | translate}}</label>
                        <input aria-required="true" [translateStrings]="translateStrings" id="positionTitle" noSpecialChars name="employerName" [(ngModel)]="newExperience.EmployerName" maxlength="256" required appFieldError placeholder="{{'Experience_Placeholder_Enter_Company_Name' | translate}}"
                        />
                    </div>
                    <div class="form-group ">
                        <label id="employerNameLabel"><span class="req">*</span>{{'Job_title' | translate}}</label>
                        <input aria-required="true" [translateStrings]="translateStrings" id="employerName" noSpecialChars name="positionTitle" [(ngModel)]="newExperience.PositionTitle" maxlength="256" required appFieldError placeholder="{{'Experience_Placeholder_Enter_Job_Title' | translate}}"
                        />
                    </div>
                    <div class="form-group ">
                        <label id="expStartDateLabel"><span class="req">*</span>{{'Start_year_Month' | translate}}</label>
                        <input aria-required="true" id="expStartDate" [translateStrings]="translateStrings" noSpecialChars name="startDate" [(ngModel)]="newExperience.StartDate" type="text" [placeholder]="getPlaceholderMonthFormat()" maxlength="9" (keypress)="allowOnlyDateFormat($event)"
                            required appFieldError />
                    </div>
                    <div class="form-group ">
                        <label id="expEndDateLabel">{{'End_year_Month' | translate}}</label>
                        <input id="expEndDate" name="expEndDate" noSpecialChars [(ngModel)]="newExperience.EndDate" type="text" [placeholder]="getPlaceholderMonthFormat()" maxlength="9" (keypress)="allowOnlyDateFormat($event)" />
                    </div>
                    <div class="form-group ">
                        <label id="responsibilitiesLabel">{{'Responsibilities' | translate}}</label>
                        <textarea id="responsibilities" noSpecialChars [(ngModel)]="newExperience.Responsibilities" maxlength="4000" placeholder="{{'Experience_Placeholder_Enter_Responsibilities' | translate}}"></textarea>
                    </div>
                    <button class="primaryButton " (click)="addExperience() "><span class="ladda-label">{{'Save_experience' | translate}}</span></button>
                </div>
                <!-- Education Form -->
                <div *ngIf="newSectionType === 'Education'" class="education-details-form">
                    <h3>{{'Existing_Education' | translate}}</h3>
                    <ul class="item-list">
                        <li *ngFor="let edu of profileDetails.Education">
                            {{ edu.Degree }} {{ edu.SchoolName }}
                            <i class="fa fa-trash remove-icon" role="button" [attr.aria-label]="'Delete education ' + edu.Degree + ' ' + edu.SchoolName" tabindex="0" (keydown.enter)="removeEducation(edu)" (click)="removeEducation(edu)" title="Remove"></i>
                        </li>
                    </ul>
                    <div class="field-group">
                        <label for="schoolName"><span class="req">*</span>{{'School_name' | translate}}</label>
                        <input aria-required="true" [translateStrings]="translateStrings" id="schoolName" name="schoolName" [(ngModel)]="newEducation.SchoolName" required appFieldError noSpecialChars maxlength="256" placeholder="{{'Education_Placeholder_Enter_School_Name' | translate}}"
                        />
                    </div>

                    <!-- DEGREE - REQUIRED -->
                    <div class="field-group">
                        <label for="degree">Degree<span class="req">*</span></label>
                        <input aria-required="true" [translateStrings]="translateStrings" id="degree" name="degree" [(ngModel)]="newEducation.Degree" required appFieldError noSpecialChars maxlength="256" placeholder="{{'Education_Placeholder_Enter_Degree' | translate}}" />
                    </div>

                    <!-- MAJOR - REQUIRED -->
                    <div class="field-group">
                        <label for="major"><span class="req">*</span> {{'Major_area_of_study' | translate}} </label>
                        <input aria-required="true" [translateStrings]="translateStrings" id="major" name="major" [(ngModel)]="newEducation.Major" required appFieldError noSpecialChars maxlength="256" placeholder="{{'Education_Placeholder_Enter_Major' | translate}}" />
                    </div>

                    <!-- GRAD YEAR - Optional -->
                    <div class="field-group">
                        <label for="gradYear">{{'Graduation_year' | translate}}</label>
                        <input id="gradYear" name="gradYear" [(ngModel)]="newEducation.GradYear" noSpecialChars placeholder="{{'Education_Placeholder_Enter_Graduation_Year' | translate}}" />
                    </div>

                    <!-- LOCATION - Optional -->
                    <div class="field-group">
                        <label for="location">{{'Label_Location' | translate}}</label>
                        <input id="location" name="location" [(ngModel)]="newEducation.Location" noSpecialChars maxlength="256" placeholder="{{'Education_Placeholder_Enter_Location' | translate}}" />
                    </div>

                    <button class="primaryButton" (click)="addEducation()"><span class="ladda-label">{{'Save_education' | translate}}</span></button>
                </div>
                <!-- Custom Section Form -->
                <div *ngIf="newSectionType==='Custom' " class="custom-section-form ">
                    <h3>{{'Modal_Existing_Custom_Sections' | translate}}</h3>
                    <ul class="item-list ">
                        <li *ngFor="let section of customSections ">
                            <ul>
                                <li *ngFor="let item of section.Items ">
                                    <span class="section-text ">{{ section.Title }}:</span>
                                    <span class="item-text ">{{ item }}</span>
                                    <i class="fa fa-trash remove-icon " role="button" [attr.aria-label]="'Delete custom item ' + section.Title + ' ' + item" tabindex="0" (keydown.enter)="removeCustomItem(section.Title, item)" (click)="removeCustomItem(section.Title, item)" title="{{'Modal_Button_Remove_Item' | translate}} "></i>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <div class="fieldcontain ">
                        <label for="customSectionTitle ">{{'CustomSection_Label_Section_Title' | translate}}</label>
                        <input [translateStrings]="translateStrings" id="customSectionTitle " maxlength="256 " name="title" noSpecialChars [(ngModel)]="newSectionTitle " required appFieldError placeholder="{{'CustomSection_Placeholder_Section_Title_Example' | translate}} " />
                    </div>

                    <div class="fieldcontain ">
                        <label for="customItem ">{{'CustomSection_Label_Item' | translate}}</label>
                        <input [translateStrings]="translateStrings" id="customItem " maxlength="256 " name="item" noSpecialChars [(ngModel)]="newSectionItem " required appFieldError placeholder="{{'CustomSection_Placeholder_Enter_Item' | translate}} " />
                    </div>
                    <div class="error " *ngIf="limitError ">{{ limitError }}</div>
                    <button class="primaryButton " (click)="addNewSection() "><span class="ladda-label">{{'CustomSection_Button_Add_Item' | translate}}</span></button>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- Separate Button Container -->
    <div class="modal-button-container lightAccentBkg">
        <div id="Preview-Next-btn-container" class="arrow-buttons-container" aria-live="polite" aria-atomic="true">
            <div class="template-label text-center mt-2">
                <small class="text-muted ladda-label">{{ 'Resume_Templates' | translate }}</small>
            </div>
            <div class="arrow-buttons">
                <button class="btn btn-outline-secondary primaryButton" aria-label="Previous Template" title="Previous Resume Template" (click)="changeTemplate('prev')">
        <i class="fa fa-chevron-left ladda-label" aria-hidden="true"></i>
    </button>
                <span class="page-number">{{ currentTemplateIndex + 1 }} / {{ templates.length }}</span>
                <button class="btn btn-outline-secondary primaryButton" aria-label="Next Template" title="Next Resume Template" (click)="changeTemplate('next')">
        <i class="fa fa-chevron-right ladda-label" aria-hidden="true"></i>
    </button>
            </div>
        </div>

        <div class="action-buttons">
            <button id="editToggleBtn" class="btn btn-primary primaryButton" (click)="toggleEditForm()" [attr.aria-label]="showEditForm ? ('Resume_TMP_Close_Editor' | translate) : ('Resume_TMP_Edit_Resume' | translate)">
            <span class="ladda-label">
           {{ (showEditForm ? 'Resume_TMP_Close_Editor' : 'Resume_TMP_Edit_Resume') | translate }}
            </span>
        </button>
            <button id="SaveMyFilesButton" class="btn btn-success primaryButton " (click)="openFileNameModal() " [attr.aria-label]="pagetype==='ResumeClick' ? ('Resume_TMP_Download_PDF' | translate) : ('Attach_File' | translate)">
            <i class="fa fa-download " *ngIf="pagetype==='ResumeClick' "></i>
            <span class="ladda-label " *ngIf="pagetype==='ResumeClick' ">{{ 'Resume_TMP_Download_PDF' | translate }}</span>
            <span class="ladda-label " *ngIf="pagetype !=='ResumeClick' ">{{ 'Attach_File' | translate }}</span>
        </button>
            <button class="btn btn-secondary rightIcons " (click)="closeModal() " aria-label="Close Resume Modal ">
            <span class="ladda-label ">{{'Button_Close' | translate }}</span>
        </button>
        </div>
    </div>

</div>

<div id="fileNameModal" class="modal file-name-modal" *ngIf="showFileNameModal " role="dialog " aria-modal="true " aria-labelledby="fileNameModalTitle ">
    <div class="modal-content baseColorPalette " cdkTrapFocus cdkTrapFocusAutoCapture tabindex="-1">
        <div class="modal-header ">
            <h2 id="fileNameModalTitle ">{{ 'Resume_TMP_Enter_File_Name' | translate }}</h2>
            <button id="closeFileNameModalBtn" class="btn close-btn " (click)="closeFileNameModal() " aria-label="Close File Name Modal " [disabled]="isLoading ">
                <span class="ladda-label"><i class="fa fa-times-circle " aria-hidden="true "></i></span>
            </button>
        </div>
        <div class="modal-body ">
            <label for="fileNameInput ">{{ 'Resume_TMP_File_Name' | translate }}</label>
            <input id="fileNameInput " noSpecialChars maxlength="255 " [(ngModel)]="fileNameInput " placeholder="{{ 'Resume_TMP_Enter_File_Name' | translate }} " [disabled]="isLoading " />
            <p id="fileNameError " class="error-text " *ngIf="errorMessage " aria-live="assertive ">
                {{ 'Please_enter_a_valid_file_name' | translate }}
            </p>
            <div class="loading-spinner " *ngIf="isLoading " aria-live="polite " aria-busy="true ">
                <div class="spinner "></div>
                <p>{{ 'Saving_resume_please_wait' | translate }}</p>
            </div>
        </div>
        <div class="modal-footer ">
            <button class="btn btn-secondary rightIcons " (click)="closeFileNameModal() " [disabled]="isLoading ">
                <span class="ladda-label ">{{ 'Button_Cancel' | translate }}</span>
            </button>
            <button id="saveFileNameButton" class="btn btn-primary primaryButton" (click)="saveResumeAsHTML() " [disabled]="isLoading ">
                <span class="ladda-label ">{{ 'Done' | translate }}</span>
            </button>
        </div>
    </div>
</div>
<div class="modal file-name-modal " *ngIf="showConfirmationModal " role="dialog " cdkTrapFocus cdkTrapFocusAutoCapture aria-modal="true " aria-labelledby="confirmationModalTitle ">
    <div class="modal-content baseColorPalette ">

        <div class="modal-header ">
            <h2 id="confirmationModalTitle ">{{ 'Unsaved_Changes_Warning' | translate }}</h2>
            <button id="closeConfirmationModalBtn" class="btn close-btn" (click)="cancelConfirmation() " aria-label="Close Confirmation Modal ">
                <span class="ladda-label"><i class="fa fa-times-circle " aria-hidden="true "></i></span>
            </button>
        </div>
        <div class="modal-body ">
            <p>{{ 'Unsaved_Changes_Alert' | translate }}</p>
        </div>
        <div class="modal-footer ">
            <button class="btn btn-secondary primaryButton " (click)="confirmClose() " [attr.aria-label]="'Done' | translate">
                <span class="ladda-label ">{{ 'Done' | translate }}</span>
            </button>
            <button class="btn btn-primary rightIcons " (click)="cancelConfirmation() " [attr.aria-label]="'Button_Cancel' | translate">
                <span class="ladda-label ">{{ 'Button_Cancel' | translate }}</span>
            </button>

        </div>
    </div>
</div>
